import * as ko from "knockout";
import * as moment from "moment";
import * as localisationHelper from "localisationHelper";

// Contexts
import DateBirthPicker, { IDateBirthPicker } from "Content/ts/Shared/Inputs/DateOfBirth/dob-datepicker";

// Enums
import { DateTimeWorkflowStates } from "Content/ts/Shared/Controls/DateTime/Services/workflowStates";

// Models
import { DateConfiguration } from "Content/ts/Models/Shared/DateTime/datePickerConfiguration";
import { DateTimeConfiguration } from "Content/ts/Models/Shared/DateTime/dateTimePickerConfiguration";

// Services
import { DateTimeFormatterService } from "Content/ts/Shared/Controls/DateTime/Services/dateTimeFormatterService";

export const Deps = {
    LocalisationHelper: localisationHelper
};

export module ConfigureControlService {
    export function ConfigureDatePickerConfiguration(context: DateBirthPicker, params: IDateBirthPicker): DateTimeConfiguration {
        return {
            AllowDateTimeClear: false,
            ComponentState: DateTimeWorkflowStates.DateMode,
            DateLabel: Deps.LocalisationHelper.getString("GenericResources", "DateOfBirth"),
            DateConfiguration: {
                View: "years",
                ShowToday: false,
                AllowClear: false,
                StartDate: ko.unwrap(context.StartDate),
                IsRequired: params.IsRequired,
                IsReadonly: params.IsReadonly,
                BetweenDates: [
                    ko.unwrap(context.MaximumAgeDate).format(DateTimeFormatterService.LocalisedMomentShortDateFormat),
                    ko.unwrap(context.MinimumAgeDate).format(DateTimeFormatterService.LocalisedMomentShortDateFormat)
                ]
            } as DateConfiguration
        } as DateTimeConfiguration;
    };
}